








































import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";
import VideoModel from "@/dex-shared/models/VideoModel";
import VideoShow from "../show/VideoShow.vue";
import pxButton from "@/dex-shared/components/px-button.vue";

export default Vue.extend({
  components: {
    VideoShow,
    pxButton
  },
  computed: {
    ...mapGetters({
      videoById: "videoById"
    }),
    video() {
      const video = this.videoById(this.videoId)
      return video;
    }
  },
  props: {
    videoId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateVideo: function(updatedVideoData: object) {
      this.$store.commit(
        "UPDATE_ENTITY", {
          entity: "videos",
          data: {
            ...this.video.raw(),
            ...updatedVideoData
          }
        }
      );
    }
  }
});
